var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { LoginType, PrincipalProvider } from '@lucidlink/dto/validation';
import { useAuthProvider } from '#context';
import { canFetchWorkspaceData, useCurrentMemberByWorkspaceId, useFilespaceListByWorkspaceId, useGetWorkspaceLoginStatus, } from '#query-hooks';
import { getWorkspaceLoginRequirements } from '#services';
export const useWorkspaceMemberActive = ({ workspace, }) => {
    _react_refresh_temp_1();
    const { filespaceId = '', workspaceId = '' } = useParams();
    const { currentUser } = useAuthProvider();
    const { query: { data: workspaceLoginStatus }, } = useGetWorkspaceLoginStatus(workspaceId);
    const shouldShowWorkspaceContent = canFetchWorkspaceData(workspaceLoginStatus);
    const { query: { data: filespacesData, isLoading: isLoadingFilespaceData }, } = useFilespaceListByWorkspaceId(workspaceId);
    const { query: { data: memberData }, } = useCurrentMemberByWorkspaceId(workspaceId);
    const { isLoggedIn, isMfaRequired, isSsoLoginRequired } = getWorkspaceLoginRequirements(workspaceLoginStatus);
    const isGuest = Boolean(memberData?.isGuest);
    const isNotLoggedInAndSsoLoginRequired = !isLoggedIn && isSsoLoginRequired;
    const isLucidUser = memberData?.provider === PrincipalProvider.LUCID;
    const isLeaveWorkspaceDisallowed = isSsoLoginRequired || isMfaRequired || !isLucidUser;
    const isActiveWorkspace = Boolean(workspace?.isOperational);
    const filespacesCount = useMemo(() => filespacesData?.length || 0, [filespacesData?.length]);
    const isLoggedWithCode = currentUser?.loginType === LoginType.VERIFICATION_CODE;
    return {
        filespaceId,
        filespacesCount,
        filespacesData,
        isActiveWorkspace,
        isGuest,
        isLeaveWorkspaceDisallowed,
        isLoadingFilespaceData,
        isLoggedWithCode,
        isNotLoggedInAndSsoLoginRequired,
        isSsoLoginRequired,
        memberData,
        shouldShowWorkspaceContent,
        workspaceLoginStatus,
    };
};
_react_refresh_temp_1(useWorkspaceMemberActive, "qgZHrq/hSogB6nokVBHYcmlX/eg=", false, () => [useParams, useAuthProvider, useGetWorkspaceLoginStatus, useFilespaceListByWorkspaceId, useCurrentMemberByWorkspaceId]);
